export interface CollectionDeleteRequest {
  collections: {
    id: number
    revision: number
  }[]
  oneOnlyCheck: boolean
  fiveYearLendCheck: boolean
}

export function CollectionDeleteRequestToJSON(
  value: CollectionDeleteRequest
): any {
  return {
    collections:
      value.collections.length !== 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              revision:
                collection.revision !== 0 ? collection.revision : undefined
            }
          })
        : undefined,
    one_only_check:
      value.oneOnlyCheck !== null ? value.oneOnlyCheck : undefined,
    five_year_lend_check:
      value.fiveYearLendCheck !== null ? value.fiveYearLendCheck : undefined
  }
}
